module.exports = __webpack_public_path__ + "static/media/Arrow_Up.18d007a2.svg";